import React, {useMemo} from "react"
import {Layout} from "./Layout";
import {useSiren} from "./SirenContext";
import {SirenMessageContentList} from "./subpages/SirenMessageContentList";
import {SirenMessageContentForm} from "./subpages/SirenMessageContentForm";

export function SirenMessageContents() {
    const {subMenuCurrent} = useSiren()

    const page = useMemo(() => {
        switch (subMenuCurrent) {
            case "create": return <SirenMessageContentForm mode="create"/>
            case "list": return <SirenMessageContentList/>
        }
        return <SirenMessageContentList/>
    }, [subMenuCurrent])

    return (
        <Layout menuCurrent="message-contents">
            {page}
        </Layout>
    )
}
